var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"cotacao-body\" class=\"cotacao-page-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"page") : depth0), depth0))
    + "\">\r\n    <div id=\"cotacao-main\" class=\"cotacao-page-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"page") : depth0), depth0))
    + "\">\r\n"
    + ((stack1 = container.invokePartial(require("./metrics.hbs"),depth0,{"name":"layouts/metrics","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(require("./metrics-fallback.hbs"),depth0,{"name":"layouts/metrics-fallback","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\r\n        <div id=\"cotacao-header\">\r\n"
    + ((stack1 = container.invokePartial(require("../elements/header.hbs"),depth0,{"name":"elements/header","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        </div>\r\n\r\n        <div id=\"cotacao-container\">\r\n            <div id=\"cotacao-content\">\r\n            </div>\r\n"
    + ((stack1 = container.invokePartial(require("../elements/loading.hbs"),depth0,{"name":"elements/loading","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        </div>\r\n\r\n"
    + ((stack1 = container.invokePartial(require("../elements/footer.hbs"),depth0,{"name":"elements/footer","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\r\n</div>\r\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./resources/templates/layouts/base.hbs
// module id = 232
// module chunks = 0